<template>
  <span data-testid="infinite-scroll-trigger" ref="trigger" />
</template>

<script>
export default {
  name: "InfiniteScrollTrigger",
  props: {
    options: {
      type: Object,
      default() {
        return {
          root: null,
          threshold: "0",
        };
      },
    },
    isLastPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      observer: null,
    };
  },
  mounted() {
    this.observer = new IntersectionObserver((entries) => {
      this.handleIntersect(entries[0]);
    }, this.options);

    this.observer.observe(this.$refs.trigger);
  },
  unmounted() {
    this.observer.disconnect();
  },
  methods: {
    handleIntersect(entry) {
      if (entry.isIntersecting && !this.isLastPage)
        this.$emit("triggerIntersected");
    },
  },
};
</script>
